export const onPhotoChanged = (applicant, photoURL) => {
    let _applicant = JSON.parse(JSON.stringify(applicant));
    _applicant.PhotoPath.Data = photoURL;
    return _applicant;
};